import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import { CurrentNextLoadCalcType } from '../schema/types';
import { UserCalendarUrl } from '../../UserDashboardUrl';

const getCurrentNextLoadCalc = () =>
  apiClient
    .get<
      CurrentNextLoadCalcType[]
    >(expand(UserCalendarUrl.CURRENT_NEXT_LOAD_CALC), {})
    .then((response) => response.data);

export const useListCurrentNextLoadCalcQuery = createApiQueryHook(
  ['user-followed-data-object-groups'],
  getCurrentNextLoadCalc,
);
